<script lang="ts">
    import { Container, Row } from "sveltestrap";
    import Bookmark from "../../../Layout/Breadcrumb/Bookmark.svelte";
    import Breadcrumb from "../../../Layout/Breadcrumb/Breadcrumb.svelte";
</script>
<Container fluid >
    <div class="page-header">
        <Row>
            <Breadcrumb title="General" home="Home" parent="Widgets" />
            <Bookmark/>
        </Row>
    </div>
</Container>
